<template>
  <el-container style="height: 600px">
    <el-header>
      <div class="header">
        <div class="headerson">
          <div style="margin: 5px; margin-left: 15px">
            <input
              v-model="parma"
              type="text"
              placeholder="搜索  入住人手机号/姓名"
            />
          </div>

          <img
            @click="push()"
            src="../assets/shuax.png"
            style="width: 25px; height: 25px"
          />

          <div style="margin-left: 20px">剩余接待：5</div>
        </div>
      </div>
    </el-header>
    <el-container>
      <el-aside width="360px" style="border: 1px solid #eee">
        <ul
          class="infinite-list"
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled"
        >
        <div v-for="(item,index) in data" :key="item.id" style="overflow: auto">
            <div  @click="toinfo(item.id,index)"  :class="activeIndex === index ? 'active' : 'item'">
              <div style="padding: 10px">
                <div style="display: flex">
                  <img
                    src="../assets/lxr.png"
                    style="width: 45px; height: 45px"
                  />
                  <div>
                    <div>
                      预定人:{{ item.personName }}
                      <img
                        src="../assets/fz.png"
                        style="width: 15px; height: 15px"
                      />
                    </div>
                    <div>
                      联系方式:{{ item.personPhone }}
                      <img
                        src="../assets/fz.png"
                        style="width: 15px; height: 15px"
                      />
                    </div>
                  </div>
                </div>

                <el-divider><i class="el-icon-tickets"></i></el-divider>
                <div style="display: flex; justify-content: space-between">
                  <div>下单时间</div>

                  <div>
                    {{ timeFormat(item.createTime) }}
                  </div>
                </div>
                <div style="display: flex; justify-content: space-between">
                  <div>房间类型</div>

                  <div>
                    {{ item.homeTypeName }}
                  </div>
                </div>

                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin-top: 7px;
                  "
                >
                  <div>当前状态</div>

                  <div>
                    <el-badge
                      is-dot
                      class="doit"
                      type="success"
                      v-if="item.isCheck == 0"
                      >待入住</el-badge
                    >
                    <el-badge
                      is-dot
                      class="doit"
                      type="info"
                      v-if="item.isCheck == 1"
                      >已入住</el-badge
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="margin-left: 10px">
            <p v-if="loading">加载中...</p>
            <p v-if="noMore">没有更多了</p>
          </div>
        </ul>
      </el-aside>
      <el-main>
        <div
          class="detail"
          style="display: flex; justify-content: center; align-items: center"
          v-if="isshowInfo"
        >
          <img src="../assets/ysms.png" style="width: 165px; height: 165px" />
        </div>
        <div class="detail" v-if="!isshowInfo">
          <div style="width: 100%">
            <el-descriptions title="" :column="4" border v-loading="loading">
              <el-descriptions-item label="房间图片"
                ><img
                  :src="info.home.homePic"
                  alt=""
                  width="100px"
                  height="95px"
              /></el-descriptions-item>
              <el-descriptions-item label="房间名称"
                ><div style="width: 200px">
                  {{ info.home.homeName }}
                </div></el-descriptions-item
              >
              <el-descriptions-item label="房间类型">{{
                info.home.homeTypeName
              }}</el-descriptions-item>
              <el-descriptions-item label="入住天数"
                >{{ info.liveDays }}天</el-descriptions-item
              >
              <el-descriptions-item label="房间单价">{{
                info.home.homePrice
              }}</el-descriptions-item>
              <el-descriptions-item label="金额小计"
                >{{ info.money }}
              </el-descriptions-item>
            </el-descriptions>

            <el-descriptions
              v-loading="loading"
              class="margin-top"
              title=""
              :column="2"
              :size="medium"
              border
            >
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-user"></i>
                  姓名
                </template>
               
                <el-tag  effect="plain">
                  {{ info.personName }}
                </el-tag>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-mobile-phone"></i>
                  手机号
                </template>
                {{ info.personPhone }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-location-outline"></i>
                  入住日期：
                </template>
                {{ info.timeStart }} 至 {{ info.timeEnd }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-tickets"></i>
                  预计到店：
                </template>
                {{ info.estimatedTime }}
              </el-descriptions-item>


              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  订单状态
                </template>


                <el-tag effect="info">
                  {{ info.payStatusName }}
                </el-tag>
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  业务流水号
                </template>
                {{ info.id }}
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  微信订单号:
                </template>
                {{ info.outTradeNo }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  订单创建时间:
                </template>
                {{ info.createTime }}
              </el-descriptions-item>

              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  客人状态：
                </template>
         
                <span v-if="info.isCheck==0">未到店</span>
                <span v-if="info.isCheck==1">已到店</span>
              </el-descriptions-item>


              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  办理入住
                </template>
                <el-button v-if="info.isCheck==0" @click="checkin(info.id)">确认到店</el-button>
                <el-button v-if="info.isCheck==1">无需办理</el-button>
              </el-descriptions-item>



            </el-descriptions>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import store from "@/store/";

export default {
  data() {
    return {
      activeIndex:"",
      isshowInfo: true,
      info: {
        home: {
          homeName: "",
        },
      },
      parma: "",
      time: "",
      loading: false,
      req: {
        parma: "",
        pageIndex: 0,
        pageCount: 3,
        query: {
          userId: "",
          personName: "",
          personPhone: "",
        },
      },
      data: [],
      modelShow: false,
      count: 0, //当前已有总数
      index: 0,
      total: 0,
      dif: 1,
    };
  },
  computed: {
    noMore() {
      return this.count >= this.total;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  mounted() {
    this.req.query.userId = this.$store.state.user.user.id;
   // this.pushdata();
  },
  watch: {
    parma: {
      handler(newName, oldName) {
        this.index = 0;
        this.dif = 1;
        this.req.pageIndex = 0;
        this.pushdata();
      },
      // 如果设置了false，那么在页面第一次渲染以后不会触发侦听器
      immediate: true,
    },
  },
  methods: {
    checkin(id){
      var that = this;
      that.loading = true;
      that.isshowInfo = false;
      that.req.parma = that.parma;
      that.$axios
        .get("/api2/business/CustomerTakeIn/" + id, {})
        .then(function (response) {
    
          that.toinfo(id,that.activeIndex)
        });
    },
    push() {
      console.log("刷新");
      this.req.parma = "";
      this.parma = "";
      this.index = 0;
      this.dif = 1;
      this.req.pageIndex = 0;
      this.pushdata();
    },
    toinfo(id,index) {
      this.activeIndex=index
      var that = this;
      that.loading = true;
      that.isshowInfo = false;
      that.req.parma = that.parma;
      that.$axios
        .get("/api2/H5/getHomeOrderInfo/" + id, {})
        .then(function (response) {
          that.info = response.data.data;
          that.loading = false;
        });
    },
    changeInput() {
      this.total = 0;
      this.pushdata();
    },

    reset() {
      this.time = [];

      this.req = {
        parma: "",
        pageIndex: 0,
        pageCount: 10,
        query: {
          personName: "",
          personPhone: "",
        },
      };
      this.req.query.userId = this.$store.state.user.user.id;
    },
    clear() {
      this.reset();
      this.pushdata();
    },
    selectByQuery() {
      if (this.time) {
        this.req.startTime = this.time[0];
        this.req.endTime = this.time[1];
      }
      this.req.pageIndex = 0;
      this.pushdata();
    },
    updateUser(row) {
      (this.modelShow = true),
        setTimeout(() => {
          this.$refs["userModel"].init(row.id); //用$refs赋值调用子组件的init方法
        }, 500);
    },
    userShowChange(visible) {
      this.modelShow = visible;
    },
    load() {
      this.loading = true;
      // setTimeout(() => {
      //   this.count += 1
      //   this.loading = false
      // }, 2000)
      // console.log(  this.count)
      this.index = this.index + 1;
      this.handleCurrentChange(this.index);
      console.log("触底刷新");
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      if (val != 1) {
        var statcount = (val - 1) * this.req.pageCount;
        this.req.pageIndex = statcount;
        console.log("当前开始index--" + statcount);
      } else {
        this.req.pageIndex = 0;
        console.log("当前开始index--" + statcount);
      }
      console.log(this.req);
      this.pushdata();
    },
    pushdata() {
      var that = this;
      that.req.parma = that.parma;
      that.$axios
        .post("/api2/business/getMyHomeOrder", this.req)
        .then(function (response) {
          if (that.dif == 1) {
            that.data = response.data.data;
            that.count = response.data.data.length;
          } else {
            if (response.data.data.length != 0) {
              that.data = that.data.concat(response.data.data);
            }
            that.count += response.data.data.length;
          }
          that.dif = 0;
          that.total = response.data.total;
          that.loading = false;
        });
    },

    timeFormat(time1) {
      var date = new Date(time1);
      var time = date.getTime();
      if (time > 0) {
        var result;
        time = parseInt(time);
        var minute = 1000 * 60;
        var hour = minute * 60;
        var day = hour * 24;
        var month = day * 30;
        var now = new Date().getTime();
        var diffValue = now - time;
        if (diffValue < 0) {
          return;
        }
        var monthC = diffValue / month;
        var weekC = diffValue / (7 * day);
        var dayC = diffValue / day;
        var hourC = diffValue / hour;
        var minC = diffValue / minute;
        if (monthC >= 1) {
          if (monthC <= 12) {
            result = "" + parseInt(monthC) + "月前";
          } else {
            result = "" + parseInt(monthC / 12) + "年前";
          }
        } else if (weekC >= 1) {
          result = "" + parseInt(weekC) + "周前";
        } else if (dayC >= 1) {
          result = "" + parseInt(dayC) + "天前";
        } else if (hourC >= 1) {
          result = "" + parseInt(hourC) + "小时前";
        } else if (minC >= 1) {
          result = "" + parseInt(minC) + "分钟前";
        } else {
          result = "刚刚";
        }
        return result;
      } else {
        return "";
      }
    },
  },
};
</script >
<style   scoped>
.headerson {
  display: flex;
  align-items: center;
}
input {
  width: 270px;
  font-size: 17px;
  height: 37px;
  background-color: rgb(219, 229, 238);
  border-radius: 28px;
  border: none;
  outline: none;
  text-indent: 3em;
  background: url(../assets/ss.png) no-repeat 5%;
  background-size: 25px 25px;
}
.header {
  background-color: rgb(246, 248, 248);
  width: 100%;
  height: 50px;
}

.active{
  width: 280px;
  height: 180px;
  border:1px dashed #3e6db8;
  background-color: rgb(252, 254, 254);
  margin-bottom: 10px;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.24);
}
.item {
  width: 280px;
  height: 180px;
  background-color: rgb(252, 254, 254);
  margin-bottom: 10px;
}
.detail {
  background-color: rgb(246, 248, 248);
  height: 100%;
  width: 100%;
}

.el-container {
  height: 100%;
}

.info {
  font-size: 25px;
}
table {
  border: 2px solid #cbcbcb;
}
</style>
